import React from 'react';
import { motion } from 'framer-motion';

const s = {
  section: {
    position: 'relative',
    width: '100%',
    height: '420px',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
  },
  bgImage: {
    position: 'absolute',
    inset: 0,
    zIndex: 0,
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  overlayMul: {
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(107,26,16,0.70)',
    mixBlendMode: 'multiply',
  },
  overlayGrad: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to right, rgba(0,0,0,0.80) 0%, rgba(0,0,0,0.50) 50%, transparent 100%)',
  },
  content: {
    position: 'relative',
    zIndex: 10,
    maxWidth: '1280px',
    margin: '0 auto',
    padding: '0 24px',
    width: '100%',
  },
  inner: {
    maxWidth: '672px',
  },
  h1: {
    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
    fontWeight: '800',
    color: '#fff',
    marginBottom: '24px',
    lineHeight: 1.15,
  },
  p: {
    fontSize: 'clamp(1rem, 1.5vw, 1.25rem)',
    color: '#e5e7eb',
    lineHeight: 1.7,
    fontWeight: '500',
    margin: 0,
  },
};

export function HeroPartner() {
  return (
    <section style={s.section}>
      <div style={s.bgImage}>
        <img
          src="https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80"
          alt="Camp tents under a sunset sky"
          style={s.img}
        />
        <div style={s.overlayMul} />
        <div style={s.overlayGrad} />
      </div>

      <div style={s.content}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          style={s.inner}
        >
          <h1 style={s.h1}>Become A Partner</h1>
          <p style={s.p}>
            Partner with us for rewards points campaigns, sweepstakes, giveaways, community projects,
            or other promotional activities or partnerships, send us a message!
            <span style={{ display: 'block', pageBreakAfter: 'always', breakAfter: 'page' }}></span>
            We would love to hear about your ideas and possible collaborations, especially ones in completely novel industries.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
